export function getProductsForm (state){
    return state.productsForm.length
    
}

export function getShowPdf (state){
    return state.show_pdf

}
